import ExpandIcon from '@mui/icons-material/OpenWith';
import { useEffect, useRef } from 'react';
import { createRoot, Root } from 'react-dom/client';

export function useExpandButton({ onClick }: { onClick: () => void }) {
  const expandButton = useRef(document.createElement('button'));
  const root = useRef<Root | undefined>();

  useEffect(() => {
    expandButton.current.className = 'expand-toggle toastui-editor-toolbar-icons'; // apply toastui styles
    expandButton.current.type = 'button'; // avoid submit on click
    expandButton.current.style.backgroundImage = 'none';
    expandButton.current.style.margin = '0';

    if (!root.current) {
      root.current = createRoot(expandButton.current);
      root.current.render(<ExpandIcon sx={{ cursor: 'pointer', mt: '4px', color: '#666666' }} />);
    }

    return () => {
      if (root.current) {
        root.current.unmount();
      }
    };
  }, []);

  useEffect(() => {
    const { current } = expandButton;
    current.addEventListener('click', onClick);

    return () => {
      current.removeEventListener('click', onClick);
    };
  }, [onClick]);

  return { expandButton: expandButton.current };
}
